// portfolio
import p1 from "../assets/images/campaign/p1.jpg";
import p2 from "../assets/images/campaign/p2.png";
import p3 from "../assets/images/campaign/p3.PNG";
import p4 from "../assets/images/campaign/p4.png";
import p5 from "../assets/images/campaign/p5.jpg";
import p10 from "../assets/images/campaign/p6.jpg";

// events
import e1 from "../assets/images/popular/e1.jpg";
import e2 from "../assets/images/popular/e2.jpg";
import e3 from "../assets/images/popular/e3.jpg";
import e4 from "../assets/images/popular/e4.jpg";

export const portfolioData = [
  {
    id: 0,
    name: "The She Unit",
    tours: "Kerala",
    image: p2,
    link: "tour-name",
    shortDes: "",
  },
  {
    id: 1,
    name: "Buckaroo Restro Bar",
    tours: "Chennai",
    image: p1,
    link: "tour-name",
  },

  {
    id: 2,
    name: "StellarX Events",
    tours: "Kovai",
    image: p3,
    link: "tour-name",
  },

  {
    id: 3,
    name: "The She Unit",
    tours: "Kerala",
    image: p4,
    link: "tour-name",
  },
  {
    id: 4,
    name: "Expo",
    tours: "Chennai",
    image: p5,
    link: "tour-name",
  },
  {
    id: 5,
    name: "Video Production",
    tours: "Chennai",
    image: p10,
    link: "tour-name",
  },
];

export const popularsData = [
  {
    id: 0,
    title: "Ads Shoot",
    image: e2,
    location: "Chennai, Tamil Nadu",
    category: ["Ads", "Marketing"],
    date: "March, 2025",
  },
  {
    id: 1,
    title: "Media Production",
    image: e3,
    location: "Chennai, Tamil Nadu",
    category: ["Video", "Digital Marketing"],
    date: "January, 2025",
  },
  {
    id: 2,
    title: "Ads Shoot",
    image: e4,
    location: "Chennai, Tamil nadu",
    category: ["SEO", "Digital Marketing"],
    date: "February, 2025",
  },
  {
    id: 3,
    title: "Video Production",
    image: e1,
    location: "Chennai, Tamil Nadu",
    category: ["Ads", "Digital Marketing"],
    date: "March, 2025",
  },
];

export const websiteData = {
  email: "info@starizenstudios.com",
  phone_one: "044 4807 0674",
  instagram: "https://www.instagram.com/starizenstudios",
  instagramDisplay: "instagram.com/starizenstudios",
  address: "Chennai, Tamil Nadu",
  company_name: "STARIZEN STUDIOS",
  moto_one: "Digital Marketing, SEO & Video Production",
  moto_two: "Built to Scale Brands",
  dev_company: "Graple",
  dev_company_url: "https://graple.us",
};
